// @flow
import * as React from 'react';
import { useSelector } from 'react-redux';

import { ReactPageContext } from 'Context/pageContext';
import ReactAppContext from 'Context/ReactAppContext';
import * as trackingApi from 'Tracking/tracking-api';
import { trackLastVisitedProducts } from 'Tracking/last-visited-tracking-api';
import { PLE } from 'Tracking/constants';
import { getLeadScore } from 'Store/lead-info/leadInfo.selector';

type Props = {
  children?: React.Node,
  pageName?: string,
  siteSection?: string,
  track?: () => void,
};
const TrackingComponent = ({ children, track, ...props }: Props) => {
  const appContext = React.useContext(ReactAppContext);
  const pageContext = React.useContext(ReactPageContext);
  const leadScoring = useSelector(getLeadScore);
  // in some cases (like the NotFoundView) the siteSection's value cannot be dynamically built
  // from the pageType and attached to the pageContext,
  // so we need to declare it in the props directly but this should be avoided
  const siteSection = props.siteSection || pageContext.siteSection;

  React.useEffect(
    () => {
      // $FlowFixMe
      trackLastVisitedProducts(pageContext, props.resortCode);
    },
    [props.pageName],
  );

  React.useEffect(
    () => {
      // pageId is not actually needed here, since the categoryGA is only used for events
      // not for page loading (the analytics team doesn't care), but it makes our API more
      // consistent
      trackingApi.setDataLayer(
        {
          ...props,
          // $FlowFixMe
          siteSection,
          ...(siteSection && siteSection.includes(PLE)
            ? { BE_customerStatus: appContext.customerType }
            : undefined),
          // $FlowFixMe
          ...(leadScoring ? { leadScoring } : null),
        },
        appContext,
        pageContext.pageId,
      );
      if (track) {
        track();
      }
    },
    [props.pageName],
  );
  return <div>{children}</div>;
};

export default TrackingComponent;
